<header class="w-100">
  <!-- <h1>{{meeting.conference?.name}}</h1> -->
  <p>Entre e confirme a presença de um ou mais servidores da sua organização para integrar a <b>Equipe de Governo</b> neste evento</p>
</header>
<main class="w-100" *ngIf="meeting">
  <div class="d-flex flex-column">
    <label>Encontro Presencial:</label>
    <span>{{meeting.name}}</span>
  </div>
  <div class="d-flex flex-column">
    <label>Municipio Anfitrião:</label>
    <span>{{meeting.localityPlace?.name || "A definir"}}</span>
  </div>
  <div class="d-flex flex-column">
    <label>Data:</label>
    <span>{{meeting.beginDate}}</span>
  </div>
  <div class="d-flex flex-column">
    <label>Local:</label>
    <span>{{ (meeting.place && meeting.address) ?  meeting.place + ' - ' + meeting.address : "A defnir" }}</span>
  </div>
</main>
<footer class="w-100 mt-4">
  <button class="cidadao" (click)="signInAcessoCidadao()">
    <span class="d-flex justify-content-center align-items-center w-100 p-2">
      <img src="assets/images/govbrbranco.png"  />
      <img src="assets/icons/cidadao.svg" alt=""/>
      <div class="button-text">
        Entrar
      </div>
    </span>
  </button>
</footer>
